import { Environment } from "../types/types";

export const getEnvironment = (): Environment => {
  if (
    window.location.hostname.endsWith(".dev") ||
    window.location.hostname.includes("localhost")
  ) {
    return "dev-au";
  }

  return "prod-au";
};
